<template>
  <div>
    <div v-if="langluageType == 'ch'" class="zixun">
      <div class="item item1">
          <img src="../images/icon-phone.png" alt="">
          <span>热线</span>
          <div class="msg phone ">010-86460766-861</div>
      </div>
      <div class="line"></div>
      <div class="item item1">
          <img src="../images/icon-qy.png" alt="">
          <span>客服</span>
          <div class="msg img-kf"><img src="../images/img-kf4.png" alt=""></div>
      </div>
      <!-- <div class="item item2 is-zx" id="btn-zx">
          <span>
              咨<br>询<br>与<br>试<br>用
          </span>
          <div class="msg zx-msg">
              <form action="" class="s-form" id="form-zx">
                  <div class="item">
                      <label for="">公司名称</label>
                      <input class="form-input" name="compnay" type="text" placeholder="" maxlength="50">
                  </div>
                  <div class="item">
                      <label for="">所在行业</label>
                      <input class="form-input" name="industry" type="text" placeholder="" maxlength="30">
                  </div>
                  <div class="item">
                      <label for="">您的姓名</label>
                      <input class="form-input" name="username" type="text" placeholder="" maxlength="20">
                  </div>
                  <div class="item">
                      <label for="">手机号码</label>
                      <input class="form-input" name="phone" type="text" placeholder="">
                  </div>
                  <div class="item item-textarea">
                      <label for="">咨询需求</label>
                      <textarea class="form-textarea" name="content" id="" cols="30" rows="10" maxlength="200"></textarea>
                  </div>
                  <a class="btn2" id="btn-zx-sub" href="javascript:;" style="width: 100%;">立即发送</a>
              </form>
          </div>
      </div> -->
  </div>
</div>
</template>
<script>
import aaa from '../js/common'
export default {
  mixins: [aaa],
    data() {
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch'
      }
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/contact.vue